

import Vue from 'vue'

/**
 * Sets real executed quantity
 * @param  payload File and id
 */
const setRealExecutedQuantity = ({ affected: affectedId }) =>
  Vue.$http.post(`purchase/real_executed_quantity/${affectedId}/`, [])
    .then()
    .catch((err) => {
      throw err
    })

export default setRealExecutedQuantity



// WEBPACK FOOTER //
// ./src/services/workPlan/setRealExecutedQuantity.js